/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */
/* eslint-disable import/no-unresolved, import/default */

import converterFieldsetTemplate from './converter-fieldset.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

/*@ngInject*/
export default function ConverterDirective($compile, $templateCache, $translate, types) {
    var linker = function (scope, element) {
        var template = $templateCache.get(converterFieldsetTemplate);
        element.html(template);
        scope.types = types;

        scope.converterTypeChanged = () => {
            if (scope.converter.type == types.converterType.CUSTOM.value) {
                if (!scope.converter.configuration) {
                    scope.converter.configuration = {};
                }
                if (!scope.converter.configuration.decoder || !scope.converter.configuration.decoder.length) {
                    scope.converter.configuration.decoder = '// Decode an uplink message from a buffer\n'+
                        '// (array) of bytes to an object of fields.\n'+
                        'var decoded = {};\n\n'+
                        '// if (port === 1) decoded.led = bytes[0];\n\n'+
                        'return decoded;\n';
                }
                if (!scope.converter.configuration.encoder || !scope.converter.configuration.encoder.length) {
                    scope.converter.configuration.encoder = '// Encode downlink messages sent as\n'+
                        '// object to an array or buffer of bytes.\n'+
                        'var bytes = [];\n\n'+
                        '// if (port === 1) bytes[0] = object.led ? 1 : 0;\n\n'+
                        'return bytes;\n';
                }
            }
        }

        $compile(element.contents())(scope);
    }
    return {
        restrict: "E",
        link: linker,
        scope: {
            converter: '=',
            isEdit: '=',
            theForm: '='
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/converter/converter.directive.js